import {HashRouter, Route, Routes, useLocation} from 'react-router-dom';
import {useEffect} from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import ExperienceLayer from './components/ExperienceLayer';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Demos from './pages/Demos';
import About from './pages/About';
import Contact from './pages/Contact';
import './App.css';
import './interactions.css';
import './cursor-effects.css';

function ScrollToTop() {
  const {pathname} = useLocation();
  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'instant'});
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const {pathname} = useLocation();
  return (
    <ErrorBoundary key={pathname}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/demos" element={<Demos />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </ErrorBoundary>
  );
}

function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <ExperienceLayer />
      <Header />
      <main>
        <AppRoutes />
      </main>
      <Footer />
    </HashRouter>
  );
}

export default App;